import React, { useContext, useEffect, useState } from 'react';
import Image from 'next/image';
import Link from 'next/link';
import styles from './styles';
import { StorefrontContext } from 'providers/storefront';

const FeaturedSectionList = ({ posts, discussions }) => {
  const { setSelectedDiscussion } = useContext(StorefrontContext);
  const [featuredPosts, setFeaturedPosts] = useState([]);

  useEffect(() => {
    const temp = posts.filter((post) => post.data.feature);
    setFeaturedPosts(temp);
  }, [posts]);

  const prepareRoutes = (post, discussions) => {
    if (!post || !discussions) {
      console.error('Post or discussions is undefined or null.');
      return { discussion: null, topic: false };
    }

    const discussionUid =
      post?.data?.discussions_group[0]?.discussion_link?.uid;

    if (!discussionUid) {
      console.error('No discussion uid found in post.');
      return { discussion: null, topic: false };
    }

    const discussion = discussions.find((disc) => disc?.uid === discussionUid);
    const topicUid = discussion?.data?.topics[0]?.topic_link?.uid;

    return {
      discussion: discussionUid,
      topic: topicUid,
    };
  };

  const handleSelectDiscussion = (post, discussions) => {
    const discussionUid =
      post?.data?.discussions_group[0]?.discussion_link?.uid;

    const discussion = discussions.find((disc) => disc?.uid === discussionUid);
    setSelectedDiscussion(discussion);
  };

  return (
    <>
      <div className="featured-wrapper">
        <h2 className="featured-title">Featured</h2>
        <div className="features-wrapper">
          {featuredPosts.map((post) => {
            const route = prepareRoutes(post, discussions);
            return (
              <Link
                href={`/knowledge-hub/${route.topic}/${post.uid}`}
                key={post.uid}
              >
                <a
                  className="features-block"
                  onClick={() => handleSelectDiscussion(post, discussions)}
                >
                  <span className="features-block-title">
                    {post.data.title}
                  </span>
                  <div className="features-block-icon">
                    <Image
                      draggable={false}
                      src="/icons/fluent_ios-arrow.png"
                      alt="icon-search"
                      width={18}
                      height={18}
                      loading="lazy"
                    />
                  </div>
                </a>
              </Link>
            );
          })}
        </div>
      </div>
      <style jsx>{styles}</style>
    </>
  );
};

export default FeaturedSectionList;
